import { Button, ButtonType } from "components/Button/Button";
import "./AdminCentre.scss";

const AdminCentre = () => {
	return (
		<div className="admin-centre">
			<Button type={ButtonType.Secondary} text="User Management" to="/usermanagement" data-test-id="admin-centre-user-button" />
			<Button type={ButtonType.Secondary} text="User Timeline Report" to="/timeline" data-test-id="admin-centre-timeline-button" />
			<Button type={ButtonType.Secondary} text="Content Usage Report" to="/contentusage" data-test-id="admin-centre-content-usage-button" />
		</div>
	);
};

export default AdminCentre;